// extracted by mini-css-extract-plugin
export var arrow = "styles-module--arrow--c0171";
export var arrowNo = "styles-module--arrow_no--70d8f";
export var arrowYes = "styles-module--arrow_yes--6e9ce";
export var centered = "styles-module--centered--a262a";
export var flex = "styles-module--flex--85757";
export var flex1 = "styles-module--flex_1--76479";
export var flexCenter = "styles-module--flex_center--549d0";
export var flexCenterCol = "styles-module--flex_center_col--0372b";
export var flexCol = "styles-module--flex_col--25eb0";
export var flexFixCenterCol = "styles-module--flex_fix_center_col--65222";
export var flexFixedCenterCol = "styles-module--flex_fixed_center_col--95baf";
export var rotating = "styles-module--rotating--e10b3";